import React from 'react';

const CompanyInfo = () => {
  const contacts = [
    {
      label: 'Besøksadresse',
      lines: ['Storgata 47, 3. etasje', '0182 Oslo', 'Norge'],
      accent: '#3B6FD4'
    },
    {
      label: 'Telefon',
      lines: ['+47 20 94 89 03', 'Man–Fre: 08:00–17:00'],
      accent: '#E8941A'
    },
    {
      label: 'E-post',
      lines: ['hei@nordpassno.com', 'support@nordpass.com'],
      accent: '#3B6FD4'
    }
  ];

  return (
    <div style={{ position: 'relative' }}>
      {/* Section label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '36px' }}>
        <div style={{ width: '28px', height: '1px', background: '#3B6FD4' }} />
        <span style={{
          fontFamily: 'monospace', fontSize: '0.6rem',
          letterSpacing: '0.3em', color: '#3B6FD4', textTransform: 'uppercase'
        }}>Finn oss</span>
      </div>
      {/* Ghost number */}
      <div style={{
        position: 'absolute', top: '-30px', right: '-10px',
        fontFamily: '"Arial Black", sans-serif',
        fontSize: '9rem', fontWeight: 900,
        color: 'rgba(232,148,26,0.05)',
        lineHeight: 1, userSelect: 'none'
      }}>02</div>
      <div style={{
        fontFamily: '"Arial Black", sans-serif',
        fontSize: 'clamp(2rem, 4vw, 3.5rem)',
        fontWeight: 900, color: '#EEF0F2',
        letterSpacing: '-0.04em', textTransform: 'uppercase',
        lineHeight: 0.9, marginBottom: '8px'
      }}>KONTAKT-</div>
      <div style={{
        fontFamily: 'Georgia, serif', fontStyle: 'italic',
        fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',
        color: '#E8941A', lineHeight: 1, marginBottom: '48px'
      }}>informasjon.</div>
      {/* Contact blocks */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '2px' }}>
        {contacts?.map((c, i) => (
          <div key={i} style={{
            background: 'rgba(255,255,255,0.03)',
            borderLeft: `3px solid ${c?.accent}`,
            padding: '24px 20px',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{
              fontFamily: 'monospace',
              fontSize: '0.55rem',
              letterSpacing: '0.3em',
              color: c?.accent,
              textTransform: 'uppercase',
              marginBottom: '12px'
            }}>{c?.label}</div>
            {c?.lines?.map((line, j) => (
              <div key={j} style={{
                fontFamily: j === 0 ? '"Arial Black", sans-serif' : 'Georgia, serif',
                fontStyle: j > 0 ? 'italic' : 'normal',
                fontSize: j === 0 ? '1rem' : '0.85rem',
                fontWeight: j === 0 ? 900 : 400,
                color: j === 0 ? '#EEF0F2' : 'rgba(238,240,242,0.5)',
                letterSpacing: j === 0 ? '-0.02em' : '0',
                lineHeight: 1.5
              }}>{line}</div>
            ))}
          </div>
        ))}
      </div>
      {/* Rotated annotation */}
      <div style={{
        marginTop: '32px',
        display: 'inline-block',
        border: '1px solid rgba(59,111,212,0.3)',
        padding: '10px 18px',
        transform: 'rotate(-1.5deg)',
        background: 'rgba(59,111,212,0.06)'
      }}>
        <div style={{
          fontFamily: 'Georgia, serif', fontStyle: 'italic',
          fontSize: '0.8rem', color: 'rgba(238,240,242,0.5)',
          lineHeight: 1.6
        }}>«Vi er stolte av å betjene norske<br />sjåfører fra Tromsø til Kristiansand.»</div>
        <div style={{
          fontFamily: 'monospace', fontSize: '0.55rem',
          color: 'rgba(59,111,212,0.6)', letterSpacing: '0.2em',
          marginTop: '8px', textTransform: 'uppercase'
        }}>— NordPass-teamet</div>
      </div>
    </div>
  );
};

export default CompanyInfo;
